import { gql } from "apollo-boost";

export default {
    LOGIN: gql`
        query Login($ic: String!, $password: String!) {
            adminLogin(input: { ic: $ic, password: $password }) {
                userId
                token
                name
                type
            }
        }
    `,
    FETCH_RANKINGS: gql`
        query FetchRankings {
            fetchRankings {
                _id
                name
            }
        }
    `,
    FETCH_PROJECTS: gql`
        query FetchProjects(
            $limit: Int!
            $page: Int!
            $name: String
        ) {
            fetchProjects(
                filter: {
                    name: $name
                }
                pagination: { limit: $limit, page: $page }
            ) {
                data {
                    _id
                   name
                }
            }
        }
    `,
    FETCH_HQ_BALANCE: gql`
        query FetchHQBalance(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $status: String
            $unitNumber: String
            $state: ID
            $commStatus: String
            $firstBatchAlert: Boolean
            $secondBatchAlert: Boolean
        ) {
            fetchHQBalance(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    unitNumber: $unitNumber
                    state: $state
                    commStatus: $commStatus
                    firstBatchAlert: $firstBatchAlert
                    secondBatchAlert: $secondBatchAlert
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    image
                    salesKit
                    spaPrice
                    rebate
                    fees
                    cashback
                    totalCommission
                    leaderRevisedComm
                    primeRevisedComm
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                        developer
                    }
                    agentCommAmount
                    leaderCommAmount
                    primeCommAmount
                    coordinatorCommAmount
                    ptp5CommAmount
                    ptp2CommAmount
                    ptp1CommAmount
                    managementCommAmount
                    sstAmount
                    agentCutAmount
                    leaderCutAmount
                    primeCutAmount
                    projectDirectorCutAmount
                    salesDirectorCutAmount
                    dndCommAmount
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                    firstBatchComm
                    secondBatchComm
                    invoiceNo
                    invoiceDate
                    receiveDate
                    secondInvoiceNo
                    secondInvoiceDate
                    secondReceiveDate
                }
            }
        }
    `,
    FETCH_CASES: gql`
        query FetchCases(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
         
        ) {
            fetchCases(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
               
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        incentive
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        incentive
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    remarks {
                        content
                        createdAt   
                        createdBy {
                            _id
                            name
                        }
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        newCommission
                        newAmount
                        commission
                        incentive
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        newCommission
                        newAmount
                        commission
                        incentive
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        incentive
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        incentive
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        incentive
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    spaDate
                    LADate
                    LODate
                    bankname
                    image
                    salesKit
                    spaPrice
                    rebatePercentage
                    rebate
                    rebate2
                    rebate3
                    bumirebate
                    legacyComm
                    leaderRevisedComm
                    primeRevisedComm
                    fees
                    remarks
                    cashback
                    totalCommission
                    totalRevisedComm
                    totalIncentive
                    leaderRevisedAmount
                    primeRevisedAmount
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    hqManualGenerated
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }
                    createdAt
                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                        coordinatorIncentive
                        leaderIncentive
                        primeIncentive
                        ptp5Incentive
                        ptp2Incentive
                        ptp1Incentive
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    FETCH_UNDERGROUND_CASES: gql`
        query FetchUndergroundCases(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $user: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $status: String
        ) {
            fetchUndergroundCases(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    user: $user
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                }
            ) {
                totals {
                    cases
                    spaPrice
                    netPrice
                    totalNetGdv
                    totalCommission
                    totalCommissionPercentage
                    totalPrimeLeaderComm
                    totalLeaderComm
                    totalPtpReferralComm
                    totalPtp2ReferralComm
                    totalPtp1ReferralComm
                    totalGroupNetGdv
                }
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    image
                    salesKit
                    spaPrice
                    rebate
                    fees
                    cashback
                    netPrice
                    status
                    bookingDate
                    unitNumber
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    commissionStatus
                    createdBy {
                        _id
                        name
                    }
                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                }
            }
        }
    `,
    FETCH_CASES_REPORT_NO_521: gql`
        query FetchCasesNo521(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $user: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $state: ID
        ) {
            fetchCasesNo521(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    user: $user
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    convertTo: $convertTo
                    convertFrom: $convertFrom
                    status: $status
                    state: $state
                }
            ) {
                totals {
                    cases
                    spaPrice
                    netPrice
                    totalNetGdv
                    totalCommission
                    totalCommissionPercentage
                    totalPrimeLeaderComm
                    totalLeaderComm
                    totalPtpReferralComm
                    totalPtp2ReferralComm
                    totalPtp1ReferralComm
                    totalGroupNetGdv
                }
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    image
                    salesKit
                    spaPrice
                    rebate
                    fees
                    cashback
                    netPrice
                    status
                    bookingDate
                    unitNumber
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    commissionStatus
                    createdBy {
                        _id
                        name
                    }
                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                }
            }
        }
    `,
    FETCH_QUALIFIED_MEMBERS: gql`
        query FetchQualifiedMembers(
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $status: String
            $unitNumber: String
        ) {
            fetchQualifiedMembers(
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    unitNumber: $unitNumber
                }
            ) {
                data {
                    member {
                        _id
                        name
                        status
                    }
                    totalNetGDV
                    fourmilliondate
                    eightmilliondate
                }
            }
        }
    `,
    FETCH_SALES_RANKING_PERCENTAGE: gql`
        query FetchSalesRankingPercentage(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $dateFrom: String
            $dateTo: String
            $status: String
            $user: ID
        ) {
            fetchSalesRankingPercentage(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    user: $user
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    member {
                        _id
                        name
                    }
                    commission
                    value
                }
            }
        }
    `,
    FETCH_CASES_SALES_RANKING: gql`
        query FetchCasesSalesRanking(
            $limit: Int!
            $page: Int!
            $project: ID
            $by: String
            $dir: String
            $date: String
            $dateFrom: String
            $dateTo: String
            $rank: ID
            $state: ID
            $status: String
            $gender: String
            $progression: String
        ) {
            fetchCasesSalesRanking(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    rank: $rank
                    state: $state
                    gender: $gender
                    progression: $progression
                }
            ) {
                pagination {
                    documents
                    by
                    dir
                    page
                    limit
                    totalPages
                }
                data {
                    ranking
                    name
                    user
                    commission
                    groupCommission
                }
            }
        }
    `,
    FETCH_CASES_QUEENDOM: gql`
        query FetchCasesQueendom(
            $limit: Int!
            $page: Int!
            $project: ID
            $by: String
            $dir: String
            $date: String
            $dateFrom: String
            $dateTo: String
            $rank: ID
            $state: ID
            $status: String
            $gender: String
        ) {
            fetchCasesQueendom(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    rank: $rank
                    state: $state
                    gender: $gender
                }
            ) {
                pagination {
                    documents
                    by
                    dir
                    page
                    limit
                    totalPages
                }
                data {
                    ranking
                    name
                    user
                    commission
                }
            }
        }
    `,
    FETCH_CASES_AGENT: gql`
        query FetchCasesAgent(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $user: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $status: String
        ) {
            fetchCasesAgent(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    user: $user
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                }
            ) {
                totals {
                    cases
                    spaPrice
                    netPrice
                    totalNetGdv
                    totalCommission
                    totalCommissionPercentage
                    totalPrimeLeaderComm
                    totalLeaderComm
                }
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                    }
                    members {
                        _id
                        commission
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                    }
                    sponsorCommissions {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                    }
                    leaderCommissions {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        newCommission
                        amount
                    }
                    ptpCommissions {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        amount
                    }
                    image
                    salesKit
                    spaPrice
                    rebate
                    fees
                    cashback
                    netPrice
                    status
                    bookingDate
                    unitNumber
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                        createdBy {
                            _id
                            name
                        }
                    project {
                            _id
                            name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                }
            }
        }
    `,
    FETCH_CASES_REPORT: gql`
        query FetchCases(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
        
        ) {
            fetchCases(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
         
                }
            ) {
                totals {
                    cases
                    spaPrice
                    netPrice
                    totalNetGdv
                    totalCommission
                    totalCommissionPercentage
                    totalPrimeLeaderComm
                    totalLeaderComm
                    totalPtpReferralComm
                    totalPtp2ReferralComm
                    totalPtp1ReferralComm
                    totalGroupNetGdv
                    totalRemainingComm
                    totalLeaderRemainingComm
                    totalPrimeLeaderRemainingComm
                    totalPTP5RemainingComm
                    totalPTP2RemainingComm
                    totalPTP1RemainingComm
                }
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    image
                    salesKit
                    spaPrice
                    rebate
                    fees
                    cashback
                    totalCommission
                    leaderRevisedComm
                    primeRevisedComm
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    hqManualGenerated
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                        createdBy {
                            _id
                            name
                        }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                        coordinatorIncentive
                        leaderIncentive
                        primeIncentive
                        ptp5Incentive
                        ptp2Incentive
                        ptp1Incentive
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    FETCH_EXPORT_REPORT: gql`
        query FetchExportReport(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $user: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $commStatus: String
            $state: ID
        ) {
            fetchExportReport(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    user: $user
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    commStatus: $commStatus
                    state: $state
                    convertTo: $convertTo
                    convertFrom: $convertFrom
                }
            ) {
                totals {
                    cases
                    spaPrice
                    netPrice
                    totalNetGdv
                    totalCommission
                    totalCommissionPercentage
                    totalPrimeLeaderComm
                    totalLeaderComm
                    totalPtpReferralComm
                    totalPtp2ReferralComm
                    totalPtp1ReferralComm
                    totalGroupNetGdv
                    totalRemainingComm
                    totalLeaderRemainingComm
                    totalPrimeLeaderRemainingComm
                    totalPTP5RemainingComm
                    totalPTP2RemainingComm
                    totalPTP1RemainingComm
                }
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                        _id
                        name
                    }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    exportMembers {
                        commission
                        newCommission
                        memberAdvancedComm
                        referralAdvancedComm
                        leaderReferralAdvancedComm
                        type
                        incentive
                        leaderIncentive
                        primeIncentive
                        leaderCommission
                        primeleaderCommission
                        coordinatorIncentive
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        coordinatorCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        referral {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        leaderReferral {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                    }
                    image
                    salesKit
                    spaPrice
                    rebate
                    fees
                    cashback
                    totalCommission
                    totalIncentive
                    leaderRevisedComm
                    primeRevisedComm
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    LODate
                    LADate
                    spaDate
                    bankname
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    hqManualGenerated
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }
                    createdAt
                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                        coordinatorIncentive
                        leaderIncentive
                        primeIncentive
                        ptp5Incentive
                        ptp2Incentive
                        ptp1Incentive
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    FETCH_EXPORT_UNDER_REPORT: gql`
    query FetchExportUnderReport(
        $limit: Int!
        $page: Int!
        $by: String
        $dir: String
        $project: ID
        $user: ID
        $date: String
        $dateFrom: String
        $dateTo: String
        $convertFrom: String
        $convertTo: String
        $status: String
        $commStatus: String
        $state: ID
    ) {
        fetchExportUnderReport(
            pagination: {
                limit: $limit
                page: $page
                sort: { by: $by, dir: $dir }
            }
            filter: {
                user: $user
                project: $project
                date: $date
                dateFrom: $dateFrom
                dateTo: $dateTo
                status: $status
                commStatus: $commStatus
                state: $state
                convertTo: $convertTo
                convertFrom: $convertFrom
            }
        ) {
            totals {
                cases
                    spaPrice
                netPrice
                totalNetGdv
                totalCommission
                totalCommissionPercentage
                totalPrimeLeaderComm
                totalLeaderComm
                totalPtpReferralComm
                totalPtp2ReferralComm
                totalPtp1ReferralComm
                totalGroupNetGdv
                totalRemainingComm
                totalLeaderRemainingComm
                totalPrimeLeaderRemainingComm
                totalPTP5RemainingComm
                totalPTP2RemainingComm
                totalPTP1RemainingComm
            }
            pagination {
                documents
                totalPages
                page
                limit
                by
                dir
            }
            data {
                _id
                coordinators {
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                }
                coordinatorCommStatus {
                    fastComm
                    firstBatchComm
                    secondBatchComm
                    fullClaimComm
                    revisedComm
                    coordinator
                }
                exportMembers {
                    commission
                    newCommission
                    memberAdvancedComm
                    referralAdvancedComm
                    leaderReferralAdvancedComm
                    type
                    incentive
                    leaderIncentive
                    primeIncentive
                    leaderCommission
                    primeleaderCommission
                    coordinatorIncentive
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    referral {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    leaderReferral {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                }
                image
                salesKit
                spaPrice
                rebate
                fees
                cashback
                totalCommission
                totalIncentive
                leaderRevisedComm
                primeRevisedComm
                netPrice
                status
                bookingDate
                convertDate
                unitNumber
                LODate
                LADate
                spaDate
                bankname
                commStatus
                firstBatchAlert
                secondBatchAlert
                hqManualGenerated
                purchaser {
                    purchaserName
                    purchaserName2
                    purchaserName3
                    purchaserName4
                    purchaserName5
                    purchaserIc
                    purchaserIc2
                    purchaserIc3
                    purchaserIc4
                    purchaserIc5
                    purchaserContact
                    purchaserContact2
                    purchaserContact3
                    purchaserContact4
                    purchaserContact5
                }
                createdBy {
                    _id
                    name
                }
                        createdAt
                project {
                    _id
                    name
                    coordinatorPercentage
                    leaderPercentage
                    preleaderPercentage
                    coordinatorIncentive
                    leaderIncentive
                    primeIncentive
                    ptp5Incentive
                    ptp2Incentive
                    ptp1Incentive
                }
                advance {
                    salesDirectorCut
                    projectDirectorCut
                    leaderCut
                    primeCut
                    agentCut
                }
            }
        }
    }
`,
    BULK_REVISED_COMM: gql`
        mutation BulkRevisedComm(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $unitNumber: String
            $state: ID
            $commStatus: String
            $firstBatchAlert: Boolean
            $secondBatchAlert: Boolean
            $firstBatch: ID
            $secondBatch: ID
            $thirdBatch: ID
            $forthBatch: ID
            $fullClaim: ID
            $batchType: String
            $leaderRevisedComm: Float
            $primeRevisedComm: Float
            $hqStatus: String
            $hqPercentage: Float
        ) {
            bulkRevisedComm(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    convertFrom: $convertFrom
                    convertTo: $convertTo
                    status: $status
                    unitNumber: $unitNumber
                    state: $state
                    commStatus: $commStatus
                    firstBatchAlert: $firstBatchAlert
                    secondBatchAlert: $secondBatchAlert
                    firstBatch: $firstBatch
                    secondBatch: $secondBatch
                    thirdBatch: $thirdBatch
                    forthBatch: $forthBatch
                    fullClaim: $fullClaim
                    batchType: $batchType
                    leaderRevisedComm: $leaderRevisedComm
                    primeRevisedComm: $primeRevisedComm
                    hqStatus: $hqStatus
                    hqPercentage: $hqPercentage
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        incentive
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    spaDate
                    LADate
                    LODate
                    bankname
                    image
                    salesKit
                    spaPrice
                    rebate
                    rebate2
                    rebate3
                    bumirebate
                    legacyComm
                    fees
                    cashback
                    totalCommission
                    leaderRevisedComm
                    primeRevisedComm
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    hqManualGenerated
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                        createdBy {
                            _id
                            name
                        }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    BULK_REVISED_AMOUNT: gql`
        mutation BulkRevisedAmount(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $unitNumber: String
            $state: ID
            $commStatus: String
            $firstBatchAlert: Boolean
            $secondBatchAlert: Boolean
            $firstBatch: ID
            $secondBatch: ID
            $thirdBatch: ID
            $forthBatch: ID
            $fullClaim: ID
            $batchType: String
            $leaderRevisedAmount: Float
            $primeRevisedAmount: Float
            $hqStatus: String
            $hqPercentage: Float
        ) {
            bulkRevisedAmount(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    convertFrom: $convertFrom
                    convertTo: $convertTo
                    status: $status
                    unitNumber: $unitNumber
                    state: $state
                    commStatus: $commStatus
                    firstBatchAlert: $firstBatchAlert
                    secondBatchAlert: $secondBatchAlert
                    firstBatch: $firstBatch
                    secondBatch: $secondBatch
                    thirdBatch: $thirdBatch
                    forthBatch: $forthBatch
                    fullClaim: $fullClaim
                    batchType: $batchType
                    leaderRevisedAmount: $leaderRevisedAmount
                    primeRevisedAmount: $primeRevisedAmount
                    hqStatus: $hqStatus
                    hqPercentage: $hqPercentage
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        incentive
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    spaDate
                    LADate
                    LODate
                    bankname
                    image
                    salesKit
                        spaPrice
                    rebate
                    rebate2
                    rebate3
                    bumirebate
                    legacyComm
                    fees
                    cashback
                    totalCommission
                    leaderRevisedComm
                    primeRevisedComm
                    leaderRevisedAmount
                    primeRevisedAmount
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    hqManualGenerated
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,

    BULK_TOTAL_COMMISSION: gql`
        mutation BulkTotalCommission(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $unitNumber: String
            $state: ID
            $commStatus: String
            $firstBatchAlert: Boolean
            $secondBatchAlert: Boolean
            $firstBatch: ID
            $secondBatch: ID
            $thirdBatch: ID
            $forthBatch: ID
            $fullClaim: ID
            $batchType: String
            $salesDirector: ID
            $totalCommission: Float
            $hqStatus: String
        ) {
            bulkTotalCommission(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    convertFrom: $convertFrom
                    convertTo: $convertTo
                    status: $status
                    unitNumber: $unitNumber
                    state: $state
                    commStatus: $commStatus
                    firstBatchAlert: $firstBatchAlert
                    secondBatchAlert: $secondBatchAlert
                    firstBatch: $firstBatch
                    secondBatch: $secondBatch
                    thirdBatch: $thirdBatch
                    forthBatch: $forthBatch
                    fullClaim: $fullClaim
                    batchType: $batchType
                    salesDirector: $salesDirector
                    totalCommission: $totalCommission
                    hqStatus: $hqStatus
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        incentive
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    spaDate
                    LADate
                    LODate
                    bankname
                    image
                    salesKit
                    spaPrice
                    rebate
                    rebate2
                    rebate3
                    bumirebate
                    legacyComm
                    fees
                    cashback
                    totalCommission
                    leaderRevisedComm
                    primeRevisedComm
                    leaderRevisedAmount
                    primeRevisedAmount
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    hqManualGenerated
                    secondBatchAlert
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    BULK_TOTAL_REVISED_COMMISSION: gql`
        mutation BulkTotalRevisedCommission(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $unitNumber: String
            $state: ID
            $commStatus: String
            $firstBatchAlert: Boolean
            $secondBatchAlert: Boolean
            $firstBatch: ID
            $secondBatch: ID
            $thirdBatch: ID
            $forthBatch: ID
            $fullClaim: ID
            $batchType: String
            $salesDirector: ID
            $totalRevisedComm: Float
            $hqStatus: String
        ) {
            bulkTotalRevisedCommission(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    convertFrom: $convertFrom
                    convertTo: $convertTo
                    status: $status
                    unitNumber: $unitNumber
                    state: $state
                    commStatus: $commStatus
                    firstBatchAlert: $firstBatchAlert
                    secondBatchAlert: $secondBatchAlert
                    firstBatch: $firstBatch
                    secondBatch: $secondBatch
                    thirdBatch: $thirdBatch
                    forthBatch: $forthBatch
                    fullClaim: $fullClaim
                    batchType: $batchType
                    salesDirector: $salesDirector
                    totalRevisedComm: $totalRevisedComm
                    hqStatus: $hqStatus
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        incentive
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    spaDate
                    LADate
                    LODate
                    bankname
                    image
                    salesKit
                    spaPrice
                    rebate
                    rebate2
                    rebate3
                    bumirebate
                    legacyComm
                    fees
                    cashback
                    totalCommission
                    totalRevisedComm
                    leaderRevisedComm
                    primeRevisedComm
                    leaderRevisedAmount
                    primeRevisedAmount
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    hqManualGenerated
                    secondBatchAlert
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    BULK_RESET_COMMISSION: gql`
    mutation BulkResetCommission(
        $limit: Int!
        $page: Int!
        $by: String
        $dir: String
        $project: ID
        $date: String
        $dateFrom: String
        $dateTo: String
        $convertFrom: String
        $convertTo: String
        $status: String
        $unitNumber: String
        $state: ID
        $commStatus: String
        $firstBatchAlert: Boolean
        $secondBatchAlert: Boolean
        $firstBatch: ID
        $secondBatch: ID
        $thirdBatch: ID
        $forthBatch: ID
        $fullClaim: ID
        $batchType: String
        $salesDirector: ID
        $hqStatus: String
    ) {
        bulkResetCommission(
            pagination: {
                limit: $limit
                page: $page
                sort: { by: $by, dir: $dir }
            }
            filter: {
                project: $project
                date: $date
                dateFrom: $dateFrom
                dateTo: $dateTo
                convertFrom: $convertFrom
                convertTo: $convertTo
                status: $status
                unitNumber: $unitNumber
                state: $state
                commStatus: $commStatus
                firstBatchAlert: $firstBatchAlert
                secondBatchAlert: $secondBatchAlert
                firstBatch: $firstBatch
                secondBatch: $secondBatch
                thirdBatch: $thirdBatch
                forthBatch: $forthBatch
                fullClaim: $fullClaim
                batchType: $batchType
                salesDirector: $salesDirector

                hqStatus: $hqStatus
            }
        ) {
            pagination {
                documents
                totalPages
                page
                limit
                by
                dir
            }
            data {
                _id
                coordinators {
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                }
                coordinatorCommStatus {
                    fastComm
                    firstBatchComm
                    secondBatchComm
                    fullClaimComm
                    revisedComm
                    coordinator
                }
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                spaDate
                LADate
                LODate
                bankname
                image
                salesKit
                spaPrice
                rebate
                rebate2
                rebate3
                bumirebate
                legacyComm
                fees
                cashback
                totalCommission
                totalRevisedComm
                leaderRevisedComm
                primeRevisedComm
                leaderRevisedAmount
                primeRevisedAmount
                netPrice
                status
                bookingDate
                convertDate
                unitNumber
                commStatus
                firstBatchAlert
                hqManualGenerated
                secondBatchAlert
                purchaser {
                    purchaserName
                    purchaserName2
                    purchaserName3
                    purchaserName4
                    purchaserName5
                    purchaserIc
                    purchaserIc2
                    purchaserIc3
                    purchaserIc4
                    purchaserIc5
                    purchaserContact
                    purchaserContact2
                    purchaserContact3
                    purchaserContact4
                    purchaserContact5
                }
                createdBy {
                    _id
                    name
                }

                project {
                    _id
                    name
                    coordinatorPercentage
                    leaderPercentage
                    preleaderPercentage
                }
                advance {
                    salesDirectorCut
                    projectDirectorCut
                    leaderCut
                    primeCut
                    agentCut
                }
            }
        }
    }
`,
    BULK_TOTAL_INCENTIVE: gql`
        mutation BulkTotalIncentive(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $unitNumber: String
            $state: ID
            $commStatus: String
            $firstBatchAlert: Boolean
            $secondBatchAlert: Boolean
            $firstBatch: ID
            $secondBatch: ID
            $thirdBatch: ID
            $forthBatch: ID
            $fullClaim: ID
            $batchType: String
            $salesDirector: ID
            $totalCommission: Float
            $totalIncentive: Float
            $hqStatus: String
        ) {
            bulkTotalIncentive(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    convertFrom: $convertFrom
                    convertTo: $convertTo
                    status: $status
                    unitNumber: $unitNumber
                    state: $state
                    commStatus: $commStatus
                    firstBatchAlert: $firstBatchAlert
                    secondBatchAlert: $secondBatchAlert
                    firstBatch: $firstBatch
                    secondBatch: $secondBatch
                    thirdBatch: $thirdBatch
                    forthBatch: $forthBatch
                    fullClaim: $fullClaim
                    batchType: $batchType
                    salesDirector: $salesDirector
                    totalCommission: $totalCommission
                    totalIncentive: $totalIncentive
                    hqStatus: $hqStatus
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        incentive
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    spaDate
                    LADate
                    LODate
                    bankname
                    image
                    salesKit
                    spaPrice
                    rebate
                    rebate2
                    rebate3
                    bumirebate
                    legacyComm
                    fees
                    cashback
                    totalCommission
                    totalIncentive
                    leaderRevisedComm
                    primeRevisedComm
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    hqManualGenerated
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    BULK_LEGACY_COMMISSION: gql`
        mutation BulkLegacyCommission(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $convertFrom: String
            $convertTo: String
            $status: String
            $unitNumber: String
            $state: ID
            $commStatus: String
            $firstBatchAlert: Boolean
            $secondBatchAlert: Boolean
            $firstBatch: ID
            $secondBatch: ID
            $thirdBatch: ID
            $forthBatch: ID
            $fullClaim: ID
            $batchType: String
            $salesDirector: ID
            $totalCommission: Float
            $hqStatus: String
            $legacyComm: Float
        ) {
            bulkLegacyCommission(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    convertFrom: $convertFrom
                    convertTo: $convertTo
                    status: $status
                    unitNumber: $unitNumber
                    state: $state
                    commStatus: $commStatus
                    firstBatchAlert: $firstBatchAlert
                    secondBatchAlert: $secondBatchAlert
                    firstBatch: $firstBatch
                    secondBatch: $secondBatch
                    thirdBatch: $thirdBatch
                    forthBatch: $forthBatch
                    fullClaim: $fullClaim
                    batchType: $batchType
                    salesDirector: $salesDirector
                    totalCommission: $totalCommission
                    hqStatus: $hqStatus
                    legacyComm: $legacyComm
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    coordinators {
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                    }
                    coordinatorCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        coordinator
                    }
                    members {
                        _id
                        commission
                        newCommission
                        incentive
                        memberAdvancedComm
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                            systemAutomated
                        }
                        type
                    }
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        newCommission
                        amount
                        baseAgent
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    ptpCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp2Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp2ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    ptp1Commissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                            nickname
                        }
                        commission
                        amount
                        ptp1ReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    spaDate
                    LADate
                    LODate
                    bankname
                    image
                    salesKit
                    spaPrice
                    rebate
                    rebate2
                    rebate3
                    bumirebate
                    legacyComm
                    fees
                    cashback
                    totalCommission
                    leaderRevisedComm
                    primeRevisedComm
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    commStatus
                    firstBatchAlert
                    secondBatchAlert
                    hqManualGenerated
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }

                    project {
                        _id
                        name
                        coordinatorPercentage
                        leaderPercentage
                        preleaderPercentage
                    }
                    advance {
                        salesDirectorCut
                        projectDirectorCut
                        leaderCut
                        primeCut
                        agentCut
                    }
                }
            }
        }
    `,
    CREATE_PROJECT: gql`
        mutation createProject(
            $name: String!
            $image: String!
            $salesDirector: ID
            $projectDirector: ID
            $picPhone: String!
            $coordinatorName: String
            $coordinatorPhone: String
            $directorName: String
            $directorPhone: String
            $coordinatorPercentage: Float!
            $preleaderPercentage: Float!
            $leaderPercentage: Float!
            $area: String!
            $state: String!
            $hold: HoldTypeEnum!
            $unit: Int
            $minSqft: Int
            $maxSqft: Int
            $minBathRoom: Int
            $maxBathRoom: Int
            $minBedRoom: Int
            $maxBedRoom: Int
            $developer: String
            $completionDate: String!
            $coordinatorIncentive: Float
            $leaderIncentive: Float
            $primeIncentive: Float
            $ptp5Incentive: Float
            $ptp2Incentive: Float
            $ptp1Incentive: Float
            $totalCommission: Float
        ) {
            createProject(
                input: {
                    name: $name
                    image: $image
                    salesDirector: $salesDirector
                    projectDirector: $projectDirector
                    picPhone: $picPhone
                    directorName: $directorName
                    directorPhone: $directorPhone
                    coordinatorName: $coordinatorName
                    coordinatorPhone: $coordinatorPhone
                    area: $area
                    state: $state
                    coordinatorPercentage: $coordinatorPercentage
                    preleaderPercentage: $preleaderPercentage
                    leaderPercentage: $leaderPercentage
                    hold: $hold
                    unit: $unit
                    minSqft: $minSqft
                    maxSqft: $maxSqft
                    minBedRoom: $minBedRoom
                    maxBedRoom: $maxBedRoom
                    minBathRoom: $minBathRoom
                    maxBathRoom: $maxBathRoom
                    developer: $developer
                    completionDate: $completionDate
                    coordinatorIncentive: $coordinatorIncentive
                    leaderIncentive: $leaderIncentive
                    primeIncentive: $primeIncentive
                    ptp5Incentive: $ptp5Incentive
                    ptp2Incentive: $ptp2Incentive
                    ptp1Incentive: $ptp1Incentive
                    totalCommission: $totalCommission
                }
            ) {
                _id
            }
        }
    `,

    EDIT_PROJECT: gql`
        mutation editProject(
            $_id: ID!
            $name: String!
            $image: String!
            $picName: String!
            $picPhone: String!
            $coordinatorName: String
            $coordinatorPhone: String
            $directorName: String
            $directorPhone: String
            $coordinatorPercentage: Float!
            $preleaderPercentage: Float!
            $leaderPercentage: Float!
            $area: String!
            $hold: HoldTypeEnum!
            $minSqft: Int!
            $maxSqft: Int!
            $unit: Int!
            $minBathRoom: Int
            $maxBathRoom: Int
            $minBedRoom: Int
            $maxBedRoom: Int
            $developerID: ID
            $developer: String
            $status: ProjectStatusTypeEnum!
            $completionDate: String!
            $salesDirector: ID
            $projectDirector: ID
            $totalCommission: Float
            $coordinatorIncentive: Float
            $leaderIncentive: Float
            $primeIncentive: Float
            $ptp5Incentive: Float
            $ptp2Incentive: Float
            $ptp1Incentive: Float
        ) {
            updateProject(
                input: {
                    _id: $_id
                    name: $name
                    image: $image
                    picName: $picName
                    picPhone: $picPhone
                    directorName: $directorName
                    directorPhone: $directorPhone
                    coordinatorName: $coordinatorName
                    coordinatorPhone: $coordinatorPhone
                    area: $area
                    coordinatorPercentage: $coordinatorPercentage
                    preleaderPercentage: $preleaderPercentage
                    leaderPercentage: $leaderPercentage
                    hold: $hold
                    unit: $unit
                    minSqft: $minSqft
                    maxSqft: $maxSqft
                    minBedRoom: $minBedRoom
                    maxBedRoom: $maxBedRoom
                    minBathRoom: $minBathRoom
                    maxBathRoom: $maxBathRoom
                    developer: $developer
                    completionDate: $completionDate
                    status: $status
                    salesDirector: $salesDirector
                    projectDirector: $projectDirector
                    totalCommission: $totalCommission
                    coordinatorIncentive: $coordinatorIncentive
                    leaderIncentive: $leaderIncentive
                    primeIncentive: $primeIncentive
                    ptp5Incentive: $ptp5Incentive
                    ptp2Incentive: $ptp2Incentive
                    ptp1Incentive: $ptp1Incentive
                    developerID: $developerID
                }
            ) {
                _id
            }
        }
    `,
    EDIT_PROJECT_COMMISSION: gql`
        mutation editProjectCommission(
            $_id: ID!
            $coordinatorPercentage: Float!
            $preleaderPercentage: Float!
            $leaderPercentage: Float!
        ) {
            updateProject(
                input: {
                    _id: $_id
                    coordinatorPercentage: $coordinatorPercentage
                    preleaderPercentage: $preleaderPercentage
                    leaderPercentage: $leaderPercentage
                }
            ) {
                _id
            }
        }
    `,
    EDIT_COORDINATOR_END_DATE: gql`
        mutation editCoordinatorEndDate(
            $_id: ID!
            $projectId: ID!
            $startDate: String
            $endDate: String!
        ) {
            editCoordinatorEndDate(
                input: {
                    _id: $_id
                    projectId: $projectId
                    endDate: $endDate
                    startDate: $startDate
                }
            ) {
                coordinators {
                    _id
                    user {
                        _id
                        name
                    }
                    startDate
                    endDate
                }
            }
        }
    `,
    ADD_COORDINATOR_TO_PROJECT: gql`
        mutation AddCoordinatorToProject(
            $projectId: ID!
            $memberId: ID!
            $startDate: String!
            $endDate: String
        ) {
            addCoordinatorToProject(
                input: {
                    projectId: $projectId
                    memberId: $memberId
                    startDate: $startDate
                    endDate: $endDate
                }
            ) {
                _id
                coordinators {
                    _id
                    user {
                        _id
                        name
                    }
                    startDate
                    endDate
                }
            }
        }
    `,
    EDIT_PROJECT_INFO: gql`
        mutation editProjectInfo(
            $_id: ID!
            $projectLocation: String!
            $projectUnits: String!
            $projectBlocks: String!
            $projectType: String!
            $projectSalesPackage: String!
            $projectCommPercentage: String!
            $projectTelegram: String!
        ) {
            editProjectInfo(
                input: {
                    _id: $_id
                    projectLocation: $projectLocation
                    projectUnits: $projectUnits
                    projectBlocks: $projectBlocks
                    projectType: $projectType
                    projectSalesPackage: $projectSalesPackage
                    projectCommPercentage: $projectCommPercentage
                    projectTelegram: $projectTelegram
                }
            ) {
                _id
            }
        }
    `,

    REMOVE_COORDINATOR_FROM_PROJECT: gql`
        mutation RemoveCoordinatorFromProject(
            $projectId: ID!
            $coordinatorId: ID!
        ) {
            removeCoordinatorFromProject(
                input: { projectId: $projectId, coordinatorId: $coordinatorId }
            ) {
                _id
                coordinators {
                    _id
                    user {
                        _id
                        name
                    }
                    startDate
                    endDate
                }
            }
        }
    `,
    ADD_PROJECT_ATTRIBUTE: gql`
        mutation AddProjectAttribute(
            $projectId: ID!
            $attribute: String!
            $value: String!
        ) {
            addProjectAttribute(
                input: {
                    projectId: $projectId
                    attribute: $attribute
                    value: $value
                }
            ) {
                _id
                attributes {
                    _id
                    attribute
                    value
                }
            }
        }
    `,
    ADD_PROJECT_GALLERY: gql`
        mutation AddProjectGallery(
            $projectId: ID!
            $url: String!
            $title: String!
        ) {
            addProjectGallery(
                input: { projectId: $projectId, url: $url, title: $title }
            ) {
                _id
                info {
                    projectGallery {
                        url
                        title
                    }
                }
            }
        }
    `,
    UPDATE_SALESKIT: gql`
        mutation UpdateSaleskit($projectId: ID!, $saleskit: String!) {
            updateSaleskit(
                input: { projectId: $projectId, saleskit: $saleskit }
            ) {
                _id
                saleskit
            }
        }
    `,
    REMOVE_ATTRIBUTE_FROM_PROJECT: gql`
        mutation RemoveAttributeFromProject(
            $projectId: ID!
            $attributeId: ID!
        ) {
            removeAttributeFromProject(
                input: { projectId: $projectId, attributeId: $attributeId }
            ) {
                _id
                attributes {
                    _id
                    attribute
                    value
                }
            }
        }
    `,

    REMOVE_GALLERY_FROM_PROJECT: gql`
        mutation RemoveGalleryFromProject($projectId: ID!, $galleryId: ID!) {
            removeGalleryFromProject(
                input: { projectId: $projectId, galleryId: $galleryId }
            ) {
                _id
                info {
                    projectGallery {
                        url
                        title
                        _id
                    }
                }
            }
        }
    `,
    CREATE_CASE: gql`
        mutation createCase(
            $image: String
            $salesKit: String
            $spaPrice: Float!
            $rebate: Float!
            $rebate2: Float
            $rebate3: Float
            $bumirebate: Float
            $fees: Float!
            $cashback: Float!
            $netPrice: Float!
            $bookingDate: String!
            $unitNumber: String!
            $purchaserName: String!
            $purchaserName2: String
            $purchaserName3: String
            $purchaserName4: String
            $purchaserName5: String
            $purchaserIc: String!
            $purchaserIc2: String
            $purchaserIc3: String
            $purchaserIc4: String
            $purchaserIc5: String
            $purchaserContact: String!
            $purchaserContact2: String
            $purchaserContact3: String
            $purchaserContact4: String
            $purchaserContact5: String
            $project: ID!
            $totalCommission: Float!
            $totalIncentive: Float
            $totalRevisedComm: Float
        ) {
            createCase(
                input: {
                    image: $image
                    salesKit: $salesKit
                    spaPrice: $spaPrice
                    rebate: $rebate
                    rebate2: $rebate2
                    rebate3: $rebate3
                    bumirebate: $bumirebate
                    fees: $fees
                    cashback: $cashback
                    netPrice: $netPrice
                    bookingDate: $bookingDate
                    unitNumber: $unitNumber
                    totalCommission: $totalCommission
                    totalIncentive: $totalIncentive
                    project: $project
                    purchaser: {
                        purchaserName: $purchaserName
                        purchaserName2: $purchaserName2
                        purchaserName3: $purchaserName3
                        purchaserName4: $purchaserName4
                        purchaserName5: $purchaserName5
                        purchaserIc: $purchaserIc
                        purchaserIc2: $purchaserIc2
                        purchaserIc3: $purchaserIc3
                        purchaserIc4: $purchaserIc4
                        purchaserIc5: $purchaserIc5
                        purchaserContact: $purchaserContact
                        purchaserContact2: $purchaserContact2
                        purchaserContact3: $purchaserContact3
                        purchaserContact4: $purchaserContact4
                        purchaserContact5: $purchaserContact5
                    }
                    totalRevisedComm: $totalRevisedComm
                }
            ) {
                _id
            }
        }
    `,
    EDIT_CASE: gql`
        mutation updateCase(
            $_id: ID!
            $image: String
            $salesKit: [String]
            $spaPrice: Float!
            $rebate: Float!
            $rebate2: Float
            $rebate3: Float
            $bumirebate: Float
            $fees: Float!
            $rebatePercentage: Float
            $cashback: Float!
            $netPrice: Float!
            $totalCommission: Float
            $totalIncentive: Float
            $bookingDate: String!
            $unitNumber: String!
            $purchaserName: String
            $purchaserName2: String
            $purchaserName3: String
            $purchaserName4: String
            $purchaserName5: String
            $purchaserIc: String
            $purchaserIc2: String
            $purchaserIc3: String
            $purchaserIc4: String
            $purchaserIc5: String
            $purchaserContact: String
            $purchaserContact2: String
            $purchaserContact3: String
            $purchaserContact4: String
            $purchaserContact5: String
            $project: ID!
            $bankname: String
            $LODate: String
            $spaDate: String
            $LADate: String
            $legacyComm: Float
            $totalRevisedComm: Float
        ) {
            updateCase(
                input: {
                    _id: $_id
                    image: $image
                    salesKit: $salesKit
                    spaPrice: $spaPrice
                    rebate: $rebate
                    rebate2: $rebate2
                    rebate3: $rebate3
                    bumirebate: $bumirebate
                    fees: $fees
                    legacyComm: $legacyComm
                    cashback: $cashback
                    netPrice: $netPrice
                    bookingDate: $bookingDate
                    unitNumber: $unitNumber
                    project: $project
                    totalCommission: $totalCommission
                    totalIncentive: $totalIncentive
                    bankname: $bankname
                    LODate: $LODate
                    spaDate: $spaDate
                    LADate: $LADate
                    rebatePercentage: $rebatePercentage
                    purchaser: {
                        purchaserName: $purchaserName
                        purchaserName2: $purchaserName2
                        purchaserName3: $purchaserName3
                        purchaserName4: $purchaserName4
                        purchaserName5: $purchaserName5
                        purchaserIc: $purchaserIc
                        purchaserIc2: $purchaserIc2
                        purchaserIc3: $purchaserIc3
                        purchaserIc4: $purchaserIc4
                        purchaserIc5: $purchaserIc5
                        purchaserContact: $purchaserContact
                        purchaserContact2: $purchaserContact2
                        purchaserContact3: $purchaserContact3
                        purchaserContact4: $purchaserContact4
                        purchaserContact5: $purchaserContact5
                    }
                    totalRevisedComm: $totalRevisedComm
                }
            ) {
                _id
            }
        }
    `,
    FETCH_PIPELINE: gql`
        query FetchPipeline(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $dateFrom: String
            $dateTo: String
            $project: ID
            $state: ID
            $salesDirector: ID
        ) {
            fetchPipeline(
                filter: {
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    project: $project
                    salesDirector: $salesDirector
                    state: $state
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                data {
                    project
                    state
                    pendingCases
                    cancelledCases
                    rejectedCases
                    allCases
                    conversionRate
                    pendingRate
                    cancellationRate
                    rejectionRate
                }
            }
        }
    `,
    FETCH_PERFORMANCE: gql`
        query FetchPerformance(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $user: String
            $salesDirector: ID
            $state: ID
        ) {
            fetchPerformance(
                filter: {
                    project: $project
                    user: $user
                    salesDirector: $salesDirector
                    state: $state
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                data {
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    rejectionRate
                    pendingRate
                    allRate
                }
            }
        }
    `,
    FETCH_WEEKLY_PERFORMANCE: gql`
        query FetchWeeklyPerformance(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $user: String
            $state: ID
            $salesDirector: ID
            $year: String
            $month: String
        ) {
            fetchWeeklyPerformance(
                filter: {
                    project: $project
                    user: $user
                    state: $state
                    salesDirector: $salesDirector
                    year: $year
                    month: $month
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                data {
                    project
                    week
                    month
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    pendingRate
                    rejectionRate
                    allRate
                    salesDirector
                }
            }
        }
    `,
    FETCH_MONTHLY_PERFORMANCE: gql`
        query FetchMonthlyPerformance(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $user: String
            $state: ID
            $salesDirector: ID
            $year: String
        ) {
            fetchMonthlyPerformance(
                filter: {
                    project: $project
                    user: $user
                    state: $state
                    salesDirector: $salesDirector
                    year: $year
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                data {
                    month
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    pendingRate
                    rejectionRate
                    allRate
                }
            }
        }
    `,
    FETCH_PRIME_PERFORMANCE: gql`
        query FetchPrimePerformance(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $dateTo: String
            $dateFrom: String
            $user: String
            $state: ID
            $salesDirector: ID
        ) {
            fetchPrimePerformance(
                filter: {
                    project: $project
                    dateTo: $dateTo
                    dateFrom: $dateFrom
                    user: $user
                    state: $state
                    salesDirector: $salesDirector
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                data {
                    user
                    bookedCases
                    pendingCases
                    cancelledCases
                    rejectedCases
                    allCases
                    conversionRate
                    cancellationRate
                    rejectionRate
                    pendingRate
                    status
                }
            }
        }
    `,
    ADD_MEMBER_TO_CASE: gql`
        mutation AddMemberToCase(
            $caseId: ID!
            $memberId: ID!
            $commission: Float!
            $incentive: Float
            $type: MemberTypeEnum
        ) {
            addMemberToCase(
                input: {
                    caseId: $caseId
                    memberId: $memberId
                    commission: $commission
                    type: $type
                    incentive: $incentive
                }
            ) {
                _id
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    incentive
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    incentive
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    incentive
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    incentive
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    incentive
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,

    ADD_UNLIMITED_UPLINE: gql`
        mutation AddMemberToCase(
            $caseId: ID!
            $memberId: ID!
            $commission: Float!
        ) {
            addUnlimitedUpline(
                input: {
                    caseId: $caseId
                    memberId: $memberId
                    commission: $commission
                }
            ) {
                _id
                members {
                    _id
                    commission
                    incentive
                    amount
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                }
                sponsorCommissions {
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    commission
                    newCommission
                    incentive
                    amount
                }
                leaderCommissions {
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    commission
                    newCommission
                    incentive
                    amount
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    incentive
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    incentive
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    incentive
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    REMOVE_MEMBER_FROM_CASE: gql`
        mutation RemoveMemberFromCase($caseId: ID!, $memberId: ID!) {
            removeMemberFromCase(
                input: { caseId: $caseId, memberId: $memberId }
            ) {
                _id
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    ADD_COORDINATOR_TO_CASE: gql`
        mutation AddCoordinatorToCase($caseId: ID!, $coordinatorId: ID!) {
            addCoordinatorToCase(
                input: { caseId: $caseId, coordinatorId: $coordinatorId }
            ) {
                _id
                coordinators {
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                }
            }
        }
    `,
    REMOVE_COORDINATOR_FROM_CASE: gql`
        mutation RemoveCoordinatorFromCase($caseId: ID!, $coordinatorId: ID!) {
            removeCoordinatorFromCase(
                input: { caseId: $caseId, coordinatorId: $coordinatorId }
            ) {
                _id
                coordinators {
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                }
            }
        }
    `,
    EDIT_COMMISSION: gql`
        mutation EditCommission(
            $memberId: ID!
            $commission: Float
            $incentive: Float
        ) {
            editCommission(
                input: {
                    memberId: $memberId
                    commission: $commission
                    incentive: $incentive
                }
            ) {
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    incentive
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    incentive
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    incentive
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    incentive
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    incentive
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    EDIT_ADVANCED_COMM: gql`
        mutation EditAdvancedComm(
            $memberId: ID!
            $advancedComm: Float!
            $type: String!
        ) {
            editAdvancedComm(
                input: {
                    memberId: $memberId
                    advancedComm: $advancedComm
                    type: $type
                }
            ) {
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    EDIT_REFERRAL_ADVANCED_COMM: gql`
        mutation EditReferralAdvancedComm(
            $memberId: ID!
            $advancedComm: Float!
            $type: String!
        ) {
            editReferralAdvancedComm(
                input: {
                    memberId: $memberId
                    advancedComm: $advancedComm
                    type: $type
                }
            ) {
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    EDIT_LEADER_REFERRAL_ADVANCED_COMM: gql`
        mutation EditLeaderReferralAdvancedComm(
            $memberId: ID!
            $advancedComm: Float!
            $type: String!
        ) {
            editLeaderReferralAdvancedComm(
                input: {
                    memberId: $memberId
                    advancedComm: $advancedComm
                    type: $type
                }
            ) {
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    amount
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    EDIT_SALES_DIRECTOR_CUT: gql`
        mutation EditSalesDirectorCut($caseId: ID!, $commission: Float!) {
            editSalesDirectorCut(
                input: { caseId: $caseId, commission: $commission }
            ) {
                advance {
                    salesDirectorCut
                }
            }
        }
    `,
    EDIT_HQ_INVOICE: gql`
        mutation EditHQInvoice(
            $caseId: ID!
            $firstBatchComm: String
            $secondBatchComm: String
            $invoiceNo: String
            $invoiceDate: String
            $receiveDate: String
            $secondInvoiceNo: String
            $secondInvoiceDate: String
            $secondReceiveDate: String
        ) {
            editHQInvoice(
                input: {
                    caseId: $caseId
                    firstBatchComm: $firstBatchComm
                    secondBatchComm: $secondBatchComm
                    invoiceNo: $invoiceNo
                    invoiceDate: $invoiceDate
                    receiveDate: $receiveDate
                    secondInvoiceNo: $secondInvoiceNo
                    secondInvoiceDate: $secondInvoiceDate
                    secondReceiveDate: $secondReceiveDate
                }
            ) {
                firstBatchComm
                secondBatchComm
                invoiceNo
                invoiceDate
                receiveDate
                secondInvoiceNo
                secondInvoiceDate
                secondReceiveDate
            }
        }
    `,
    EDIT_PROJECT_DIRECTOR_CUT: gql`
        mutation EditProjectDirectorCut($caseId: ID!, $commission: Float!) {
            editProjectDirectorCut(
                input: { caseId: $caseId, commission: $commission }
            ) {
                advance {
                    projectDirectorCut
                }
            }
        }
    `,
    EDIT_ADVANCE: gql`
        mutation EditAdvance(
            $caseId: ID!
            $agentCut: Float!
            $leaderCut: Float!
            $primeCut: Float!
        ) {
            editAdvance(
                input: {
                    caseId: $caseId
                    agentCut: $agentCut
                    leaderCut: $leaderCut
                    primeCut: $primeCut
                }
            ) {
                advance {
                    agentCut
                    leaderCut
                    primeCut
                }
            }
        }
    `,
    EDIT_COMMISSION_STATUS: gql`
        mutation EditCommissionStatus(
            $memberId: ID
            $fastComm: Float
            $firstBatchComm: Float
            $secondBatchComm: Float
            $fullClaimComm: Float
            $revisedComm: Float
            $type: String!
            $caseId: ID!
        ) {
            editCommissionStatus(
                input: {
                    caseId: $caseId
                    memberId: $memberId
                    fastComm: $fastComm
                    firstBatchComm: $firstBatchComm
                    secondBatchComm: $secondBatchComm
                    fullClaimComm: $fullClaimComm
                    revisedComm: $revisedComm
                    type: $type
                }
            ) {
                coordinatorCommStatus {
                    fastComm
                    firstBatchComm
                    secondBatchComm
                    fullClaimComm
                    revisedComm
                    coordinator
                }
                members {
                    _id
                    commission
                    newCommission
                    incentive
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }   
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                        systemAutomated
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    amount
                    incentive
                    baseAgent
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    newCommission
                    incentive
                    amount
                    baseAgent
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    incentive
                    amount
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    incentive
                    amount
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                        nickname
                    }
                    commission
                    incentive
                    amount
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    EDIT_COORDINATOR_COMMISSION_STATUS: gql`
        mutation EditCoordinatorCommissionStatus(
            $memberId: ID!
            $fastComm: Float
            $firstBatchComm: Float
            $secondBatchComm: Float
            $fullClaimComm: Float
            $revisedComm: Float
            $type: String!
            $case: ID!
        ) {
            editCoordinatorCommissionStatus(
                input: {
                    memberId: $memberId
                    fastComm: $fastComm
                    firstBatchComm: $firstBatchComm
                    secondBatchComm: $secondBatchComm
                    fullClaimComm: $fullClaimComm
                    revisedComm: $revisedComm
                    type: $type
                    case: $case
                }
            ) {
                coordinatorCommStatus {
                    fastComm
                    firstBatchComm
                    secondBatchComm
                    fullClaimComm
                    revisedComm
                    coordinator
                }
            }
        }
    `,

    EDIT_PURCHASER: gql`
        mutation EditPurchaser(
            $caseId: ID!
            $purchaserName: String!
            $purchaserName2: String
            $purchaserName3: String
            $purchaserName4: String
            $purchaserName5: String
            $purchaserIc: String!
            $purchaserIc2: String
            $purchaserIc3: String
            $purchaserIc4: String
            $purchaserIc5: String
            $purchaserContact: String!
            $purchaserContact2: String
            $purchaserContact3: String
            $purchaserContact4: String
            $purchaserContact5: String
        ) {
            editPurchaser(
                input: {
                    caseId: $caseId
                    purchaserName: $purchaserName
                    purchaserName2: $purchaserName2
                    purchaserName3: $purchaserName3
                    purchaserName4: $purchaserName4
                    purchaserName5: $purchaserName5
                    purchaserIc: $purchaserIc
                    purchaserIc2: $purchaserIc2
                    purchaserIc3: $purchaserIc3
                    purchaserIc4: $purchaserIc4
                    purchaserIc5: $purchaserIc5
                    purchaserContact: $purchaserContact
                    purchaserContact2: $purchaserContact2
                    purchaserContact3: $purchaserContact3
                    purchaserContact4: $purchaserContact4
                    purchaserContact5: $purchaserContact5
                }
            ) {
                _id
            }
        }
    `,
    FETCH_USERS: gql`
        query FetchUsers(
            $name: String
            $email: String
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $status: String
            $type: String
            $birthdayMonth: String
        ) {
            fetchUsers(
                filters: {
                    name: $name
                    email: $email
                    status: $status
                    type: $type
                    birthdayMonth: $birthdayMonth
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    name
                    email
                    type
                    password
                    status
                    contact
                    ic
                    dob
                   
                }
            }
        }
    `,
    EDIT_USER_DETAILS: gql`
        mutation EditUserDetails(
            $userId: ID!
            $name: String!
            $email: String!
            $type: UserTypeEnum
            $password: String
            $status: StatusTypeEnum
        ) {
            editUserDetails(
                input: {
                    userId: $userId
                    name: $name
                    email: $email
                    type: $type
                    password: $password
                    status: $status
                }
            ) {
                _id
            }
        }
    `,

    CHANGE_PASSWORD: gql`
    mutation ChangePassword($password: String!, $currentPassword: String!) {
        changePassword(
            password: $password
            currentPassword: $currentPassword
        ) {
            _id
        }
    }
`,
    EDIT_USER: gql`
        mutation UpdateUser(
            $userId: ID!
            $name: String
            $email: String
            $ic: String
            $contact: String
            $type: UserTypeEnum
            $password: String
            $status: StatusTypeEnum
        ) {
            updateUser(
                userId: $userId
                input: {
                    name: $name
                    email: $email
                    ic: $ic
                    contact: $contact
                    type: $type
                    password: $password
                    status: $status
                }
            ) {
                _id
            }
        }
    `,
    GENERATE_IK_SIGNATURE: gql`
        query {
            generateImageKitSignature {
                signature
                token
                expire
            }
        }
    `,
    UPDATE_DREAMPOINTS: gql`
        mutation UpdateDreamPoints($userId: ID!, $value: Int!) {
            updateDreamPoints(userId: $userId, value: $value) {
                _id
            }
        }
    `,
    UPDATE_CASE_STATUS: gql`
        mutation UpdateCaseStatus(
            $id: ID!
            $status: String!
        ) {
            updateCaseStatus(
                input: { id: $id, status: $status }
            ) {
                _id
            }
        }
    `,
    UPDATE_CASE_REMARKS: gql`
        mutation UpdateCaseRemarks($id: ID!, $remarks: String) {
            updateCaseRemarks(input: { id: $id, remarks: $remarks }) {
                _id
                remarks {
                    content
                    createdAt   
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,
    UPDATE_COMM_CASE_STATUS: gql`
        mutation UpdateCommCaseStatus(
            $id: ID!
            $commStatus: CaseCommStatusTypeEnum!
        ) {
            updateCommCaseStatus(input: { id: $id, commStatus: $commStatus }) {
                _id
            }
        }
    `,
    UPDATE_USER_STATUS: gql`
        mutation UpdateUserStatus(
            $id: ID!
            $status: StatusTypeEnum!
        ) {
            updateUserStatus(
                input: {
                    id: $id
                    status: $status
                }
            ) {
                _id
            }
        }
    `,
    UPDATE_SECOND_REFERRAL: gql`
        mutation UpdateSecondReferral($id: ID!, $secondReferral: ID!) {
            updateSecondReferral(
                input: { id: $id, secondReferral: $secondReferral }
            ) {
                _id
            }
        }
    `,
    ADD_CP58_TO_USER: gql`
        mutation AddCp58ToUser($id: ID!, $cp58: String!) {
            addCp58ToUser(input: { id: $id, cp58: $cp58 }) {
                _id
            }
        }
    `,
    UPDATE_USER_RANKING: gql`
        mutation UpdateUserRanking(
            $id: ID!
            $ranking: RankingTypeEnum!
            $preleaderDate: String
            $leaderDate: String
            $preleaderprogressionDate: String
            $seniorleaderDate: String
            $omcDate: String
            $pmcDate: String
            $emcDate: String
            $smcDate: String
            $rankEmailSend: Boolean
            $memberclubEmailSend: Boolean
        ) {
            updateUserRanking(
                input: {
                    id: $id
                    ranking: $ranking
                    preleaderDate: $preleaderDate
                    leaderDate: $leaderDate
                    preleaderprogressionDate: $preleaderprogressionDate
                    seniorleaderDate: $seniorleaderDate
                    omcDate: $omcDate
                    smcDate: $smcDate
                    emcDate: $emcDate
                    pmcDate: $pmcDate
                    rankEmailSend: $rankEmailSend
                    memberclubEmailSend: $memberclubEmailSend
                }
            ) {
                _id
            }
        }
    `,
    UPDATE_COMMISSION_STATUS: gql`
        mutation UpdateCommissionStatus(
            $id: ID!
            $commissionStatus: CommissionStatusTypeEnum!
            $subsidyStatus: CommissionStatusTypeEnum!
            $type: projectUnitsEnum!
            $show: Boolean!
        ) {
            updateCommissionStatus(
                input: {
                    id: $id
                    commissionStatus: $commissionStatus
                    subsidyStatus: $subsidyStatus
                    type: $type
                    show: $show
                }
            ) {
                _id
                commissionStatus
                subsidyStatus
                type
                show
            }
        }
    `,
    CREATE_USER: gql`
        mutation createUser(
            $name: String!
            $email: String!
            $type: UserTypeEnum!
            $password: String!
            $ic: String!
            $contact: String!
        ) {
            createUser(
                input: {
                    name: $name
                    email: $email
                    type: $type
                    password: $password
                    ic: $ic
                    contact: $contact
                }
            ) {
                _id
            }
        }
    `,
    CREATE_PAYMENT_VOUCHER: gql`
        mutation createPaymentVoucher(
            $payee: ID!
            $method: MethodTypeEnum!
            $date: String!
            $batch: String!
            $orderNo: String!
            $address: String!
            $amount: Float!
            $address2: String
            $amount2: Float
            $address3: String
            $amount3: Float
            $address4: String
            $amount4: Float
            $address5: String
            $amount5: Float
            $fastComm: Float!
            $calculatePoints: PaymentVoucherCalculatePointsEnum!
        ) {
            createPaymentVoucher(
                input: {
                    payee: $payee
                    method: $method
                    date: $date
                    batch: $batch
                    status: valid
                    calculatePoints: $calculatePoints
                    orderNo: $orderNo
                    item: { address: $address, amount: $amount }
                    item2: { address: $address2, amount: $amount2 }
                    item3: { address: $address3, amount: $amount3 }
                    item4: { address: $address4, amount: $amount4 }
                    item5: { address: $address5, amount: $amount5 }
                    fastComm: $fastComm
                }
            ) {
                _id
            }
        }
    `,
    UPDATE_PAYMENT_VOUCHER: gql`
        mutation updatePaymentVoucher(
            $id: ID!
            $date: String!
            $batch: String!
            $orderNo: String!
            $fastComm: Float!
        ) {
            updatePaymentVoucher(
                input: {
                    id: $id
                    date: $date
                    batch: $batch
                    orderNo: $orderNo
                    fastComm: $fastComm
                }
            ) {
                _id
            }
        }
    `,
    FETCH_PAYMENT_VOUCHERS: gql`
        query FetchPaymentVouchers(
            $limit: Int!
            $page: Int!
            $status: String
            $calculatePoints: String
            $payee: String
            $batch: String
            $dateFrom: String
            $dateTo: String
        ) {
            fetchPaymentVouchers(
                filters: {
                    payee: $payee
                    batch: $batch
                    status: $status
                    calculatePoints: $calculatePoints
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    payee {
                        _id
                        name
                        nickname
                        code
                    }
                    date
                    method
                    batch
                    status
                    calculatePoints
                    orderNo
                    item {
                        amount
                        address
                    }
                    item2 {
                        amount
                        address
                    }
                    item3 {
                        amount
                        address
                    }
                    item4 {
                        amount
                        address
                    }
                    item5 {
                        amount
                        address
                    }
                    fastComm
                    createdBy {
                        _id
                        name
                    }
                }
                totals {
                    totalVoucherAmount
                    fastCommAmount
                }
            }
        }
    `,
    FETCH_VOUCHERS_SUMMARY: gql`
        query FetchVouchersSummary(
            $limit: Int!
            $page: Int!
            $status: String
            $payee: String
            $batch: String
            $dateFrom: String
            $dateTo: String
        ) {
            fetchVouchersSummary(
                filters: {
                    payee: $payee
                    batch: $batch
                    status: $status
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    page
                    limit
                    documents
                    totalPages
                }
                data {
                    payee {
                        _id
                        name
                        nickname
                        code
                    }
                    amount
                }
            }
        }
    `,
    UPDATE_PAYMENT_VOUCHER_STATUS: gql`
        mutation UpdatePaymentVoucherStatus(
            $id: ID!
            $status: PaymentVoucherStatusTypeEnum!
        ) {
            updatePaymentVoucherStatus(input: { id: $id, status: $status }) {
                _id
            }
        }
    `,
    UPDATE_PAYMENT_VOUCHER_COMMISSION: gql`
        mutation UpdatePaymentVoucherCommission($id: ID!, $fastComm: Float!) {
            updatePaymentVoucherCommission(
                input: { id: $id, fastComm: $fastComm }
            ) {
                _id
            }
        }
    `,
    UPDATE_PAYMENT_VOUCHER_CALCULATE_POINTS: gql`
        mutation UpdatePaymentVoucherCalculatePoints(
            $id: ID!
            $calculatePoints: PaymentVoucherCalculatePointsEnum!
        ) {
            updateCalculatePointsStatus(
                input: { id: $id, calculatePoints: $calculatePoints }
            ) {
                _id
            }
        }
    `,
    FETCH_VIDEOS: gql`
        query FetchVideos($limit: Int!, $page: Int!) {
            fetchVideos(pagination: { limit: $limit, page: $page }) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    name
                    url
                }
            }
        }
    `,
    CREATE_VIDEO: gql`
        mutation CreateVideo($name: String!, $url: String!) {
            createVideo(input: { name: $name, url: $url }) {
                _id
            }
        }
    `,
    EDIT_VIDEO: gql`
        mutation UpdateVideo($_id: ID!, $name: String!, $url: String!) {
            updateVideo(input: { _id: $_id, name: $name, url: $url }) {
                _id
            }
        }
    `,
    DELETE_VIDEO: gql`
        mutation DeleteVideo($_id: ID!) {
            deleteVideo(input: { _id: $_id }) {
                _id
            }
        }
    `,
    FETCH_BANNERS: gql`
        query FetchBanners(
            $limit: Int!
            $page: Int!
            $type: String!
            $state: String!
            $agent: ID
        ) {
            fetchBanners(
                filter: { type: $type, state: $state, agent: $agent }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    name
                    url
                    type
                    position
                    state {
                        _id
                        name
                    }
                    agent {
                        _id
                        name
                        nickname
                    }
                }
            }
        }
    `,
    CREATE_BANNER: gql`
        mutation CreateBanner(
            $name: String!
            $url: String!
            $state: String!
            $type: BannerTypeEnum!
            $agent: ID!
        ) {
            createBanner(
                input: {
                    name: $name
                    url: $url
                    type: $type
                    state: $state
                    agent: $agent
                }
            ) {
                _id
            }
        }
    `,
    EDIT_BANNER: gql`
        mutation UpdateBanner(
            $_id: ID!
            $name: String!
            $position: Int!
            $url: String!
            $type: BannerTypeEnum!
            $agent: ID!
        ) {
            updateBanner(
                input: {
                    _id: $_id
                    name: $name
                    url: $url
                    type: $type
                    position: $position
                    agent: $agent
                }
            ) {
                _id
            }
        }
    `,
    DELETE_BANNER: gql`
        mutation DeleteBanner($_id: ID!) {
            deleteBanner(input: { _id: $_id }) {
                _id
            }
        }
    `,
    FETCH_ALL_AREAS: gql`
        query FetchAllAreas {
            fetchAllAreas {
                _id
                name
            }
        }
    `,
    FETCH_ALL_STATES: gql`
        query FetchAllStates {
            fetchStates {
                _id
                name
            }
        }
    `,
    FETCH_AREAS: gql`
        query FetchAreas($limit: Int!, $page: Int!) {
            fetchAreas(pagination: { limit: $limit, page: $page }) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    name
                }
            }
        }
    `,
    CREATE_AREA: gql`
        mutation CreateArea($name: String!) {
            createArea(input: { name: $name }) {
                _id
            }
        }
    `,
    EDIT_AREA: gql`
        mutation UpdateArea($_id: ID!, $name: String!) {
            updateArea(input: { _id: $_id, name: $name }) {
                _id
            }
        }
    `,
    FETCH_CAMPAIGNS: gql`
        query FetchCampaigns($limit: Int!, $page: Int!, $type: String!) {
            fetchCampaigns(
                filter: { type: $type }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    name
                    position
                    url
                    type
                    cn_notes
                    en_notes
                }
            }
        }
    `,
    CREATE_CAMPAIGN: gql`
        mutation CreateCampaign(
            $name: String!
            $url: String!
            $type: CampaignTypeEnum!
            $en_notes: String
            $cn_notes: String
            $position: Int!
        ) {
            createCampaign(
                input: {
                    name: $name
                    url: $url
                    position: $position
                    type: $type
                    cn_notes: $cn_notes
                    en_notes: $en_notes
                }
            ) {
                _id
            }
        }
    `,
    EDIT_CAMPAIGN: gql`
        mutation UpdateCampaign(
            $_id: ID!
            $name: String!
            $position: Int!
            $url: String!
            $type: CampaignTypeEnum!
            $en_notes: String
            $cn_notes: String
        ) {
            updateCampaign(
                input: {
                    _id: $_id
                    name: $name
                    url: $url
                    type: $type
                    cn_notes: $cn_notes
                    en_notes: $en_notes
                    position: $position
                }
            ) {
                _id
            }
        }
    `,
    DELETE_CAMPAIGN: gql`
        mutation DeleteCampaign($_id: ID!) {
            deleteCampaign(input: { _id: $_id }) {
                _id
            }
        }
    `,
    FETCH_EVENTS: gql`
        query FetchEvents($limit: Int!, $page: Int!) {
            fetchEvents(pagination: { limit: $limit, page: $page }) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    start
                    end
                    title
                    start_time
                    end_time
                    location
                    image
                }
            }
        }
    `,
    FETCH_PRIME_SALES_REPORT: gql`
        query FetchPrimeSalesReport {
            fetchPrimeSalesReport {
                data {
                    user
                    personalBookingSales2021
                    convertUnit2021
                    convertPercentage2021
                    personalNetGdv2021
                    convertNetGdv2021
                    netGdvPercentage2021
                    groupBookingSales2021
                    groupConvertUnit2021
                    groupConvertPercentage2021
                    groupPersonalNetGdv2021
                    groupConvertNetGdv2021
                    groupNetGdvPercentage2021
                    personalBookingSales2022
                    convertUnit2022
                    convertPercentage2022
                    personalNetGdv2022
                    convertNetGdv2022
                    netGdvPercentage2022
                    groupBookingSales2022
                    groupConvertUnit2022
                    groupConvertPercentage2022
                    groupPersonalNetGdv2022
                    groupConvertNetGdv2022
                    groupNetGdvPercentage2022
                    personalBookingSales2023
                    convertUnit2023
                    convertPercentage2023
                    personalNetGdv2023
                    convertNetGdv2023
                    netGdvPercentage2023
                    groupBookingSales2023
                    groupConvertUnit2023
                    groupConvertPercentage2023
                    groupPersonalNetGdv2023
                    groupConvertNetGdv2023
                    groupNetGdvPercentage2023
                    growthPersonalSales22
                    growthPersonalNetGdv22
                    growthConvertUnit22
                    growthConvertNetGdv22
                    growthGroupSales22
                    growthGroupNetGdv22
                    growthGroupConvertUnit22
                    growthGroupConvertNetGdv22
                    growthPersonalSales23
                    growthPersonalNetGdv23
                    growthConvertUnit23
                    growthConvertNetGdv23
                    growthGroupSales23
                    growthGroupNetGdv23
                    growthGroupConvertUnit23
                    growthGroupConvertNetGdv23
                }
            }
        }
    `,
    FETCH_MONTHLY_SALES_REPORT: gql`
        query FetchMonthlySalesReport($user: ID) {
            fetchMonthlySalesReport(filter: { user: $user }) {
                data {
                    date
                    personalBookingSales
                    convertUnit
                    cancelledUnit
                    convertPercentage
                    personalNetGdv
                    convertNetGdv
                    cancelledNetGdv
                    netGdvPercentage
                    groupBookingSales
                    groupConvertUnit
                    groupConvertPercentage
                    groupPersonalNetGdv
                    groupConvertNetGdv
                    groupNetGdvPercentage
                    groupCancelledUnit
                    groupCancelledNetGdv
                }
            }
        }
    `,
    CREATE_EVENT: gql`
        mutation CreateEvent(
            $start: String!
            $end: String!
            $title: String!
            $start_time: String
            $end_time: String
            $location: String!
            $image: String
        ) {
            createEvent(
                input: {
                    start: $start
                    end: $end
                    title: $title
                    start_time: $start_time
                    end_time: $end_time
                    location: $location
                    image: $image
                }
            ) {
                _id
            }
        }
    `,
    EDIT_EVENT: gql`
        mutation EditEvent(
            $_id: ID!
            $start: String!
            $end: String!
            $title: String!
            $start_time: String
            $end_time: String
            $location: String!
            $image: String
        ) {
            updateEvent(
                input: {
                    _id: $_id
                    start: $start
                    end: $end
                    title: $title
                    start_time: $start_time
                    end_time: $end_time
                    location: $location
                    image: $image
                }
            ) {
                _id
            }
        }
    `,
    DELETE_EVENT: gql`
        mutation DeleteEvent($_id: ID!) {
            deleteEvent(input: { _id: $_id }) {
                _id
            }
        }
    `,
    FETCH_ALL_DEVELOPERS: gql`
        query FetchAllDevelopers {
            fetchAllDevelopers {
                _id
                name
            }
        }
    `,
    FETCH_DEVELOPERS: gql`
        query FetchDevelopers($limit: Int!, $page: Int!) {
            fetchDevelopers(pagination: { limit: $limit, page: $page }) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    name
                    status
                }
            }
        }
    `,
    CREATE_DEVELOPER: gql`
        mutation CreateDeveloper(
            $name: String!
            $status: DeveloperStatusTypeEnum!
        ) {
            createDeveloper(input: { name: $name, status: $status }) {
                _id
            }
        }
    `,
    EDIT_DEVELOPER: gql`
        mutation UpdateDeveloper(
            $_id: ID!
            $name: String!
            $status: DeveloperStatusTypeEnum!
        ) {
            updateDeveloper(
                input: { _id: $_id, name: $name, status: $status }
            ) {
                _id
            }
        }
    `,
    DELETE_DEVELOPER: gql`
        mutation DeleteDeveloper($_id: ID!) {
            deleteDeveloper(input: { _id: $_id }) {
                _id
            }
        }
    `,
};
